module.exports = __webpack_public_path__ + "img/hele.df596b88.jpg";